import {Arr, Bool, Num, Obj, OptNum, OptStr, Str} from '@repo/shared/api/core/api_schema';
import type {SchemaToType} from '@repo/shared/api/core/api_schema';

export const Tf1SeasonSchema = Obj({
  id: Str(),
  label: Str(),
  season: OptNum(),
  reportedVideoCount: Num(),
});
export type FrontendTf1Season = SchemaToType<typeof Tf1SeasonSchema>;

export const Tf1VideoSchema = Obj({
  videoId: Str(),
  listId: Str(),
  title: Str(),
  kind: Str<'episode' | 'extra'>(),
  season: OptNum(),
  episode: OptNum(),
  part: OptNum(),
  durationSeconds: OptNum(),
  url: Str(),
  state: Str<'catalogued' | 'queued' | 'downloading' | 'complete' | 'blocked'>(),
  bytes: OptNum(),
  completedAt: OptNum(),
  errorCode: OptStr(),
  retryAt: OptNum(),
});
export type FrontendTf1Video = SchemaToType<typeof Tf1VideoSchema>;

export const Tf1CataloguePageSchema = Obj({
  enabled: Bool(),
  seasons: Arr(Tf1SeasonSchema),
  videos: Arr(Tf1VideoSchema),
  paginationToken: OptStr(),
  discoveryCompletedAt: OptNum(),
  downloadsPaused: Bool(),
  cooldownUntil: OptNum(),
});
export type Tf1CataloguePage = SchemaToType<typeof Tf1CataloguePageSchema>;
